module.exports = require("./../../_gen/starling/geom/Polygon");